import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';
import {
	type UIAnalyticsEvent,
	type AnalyticsAttributes,
	fireUIAnalytics,
	fireOperationalAnalytics,
	fireTrackAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { EXPERIMENT_KEY } from './constants';

export const fireButtonAnalytics = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	actionSubjectId: string,
	attributes?: AnalyticsAttributes,
) => {
	fireUIAnalytics(
		createAnalyticsEvent({
			actionSubject: 'button',
			action: 'clicked',
			source: 'jira',
		}),
		actionSubjectId,
		{
			...attributes,
		},
	);
};

export const fireErrorAnalytics = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	reason: string,
) => {
	fireOperationalAnalytics(
		createAnalyticsEvent({
			source: 'jira',
		}),
		'experiment error',
		{
			reason,
			experimentKey: EXPERIMENT_KEY,
		},
	);
};

export const fireTrackAnalyticsEvent = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	actionSubjectId: string,
	attributes?: AnalyticsAttributes,
) => {
	fireTrackAnalytics(
		createAnalyticsEvent({
			source: 'jira',
		}),
		actionSubjectId,
		{
			experimentKey: EXPERIMENT_KEY,
			...attributes,
		},
	);
};
